import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import CartSidebar from '../cart/CartSidebar'
import { useCart } from '../../contexts/CartContext'
import { ChefHat, LogOut, LogIn, UserPlus } from 'lucide-react'

// Rutas del sitio público estilo Metalza — llevan su propio chrome (SiteLayout)
const SITE_ROUTES = ['/', '/tienda', '/nosotros', '/contacto', '/promociones', '/cotizar']

export const PublicLayout = () => {
  const location = useLocation()
  const isSiteRoute =
    SITE_ROUTES.includes(location.pathname) || location.pathname.startsWith('/categoria')
  const isAuthPage = ['/login', '/register', '/forgot-password'].includes(location.pathname)
  const isCartFlow = location.pathname.startsWith('/cart') || location.pathname.startsWith('/checkout')
  const { isAuthenticated, logout, user } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    const ok = window.confirm('¿Seguro que deseas cerrar sesión?')
    if (!ok) return
    await logout()
    navigate('/')
  }

  const { isCheckoutOpen, closeCheckout } = useCart()

  // Auth pages render clean — no header
  if (isAuthPage) {
    return (
      <div className="min-h-screen">
        <Outlet />
        {!isAuthPage && <CartSidebar />}
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header — clean, minimal (no se muestra en rutas del sitio: SiteLayout trae su chrome) */}
      {!isSiteRoute && (
        <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-lg bg-primary-700 flex items-center justify-center">
                <ChefHat className="w-5 h-5 text-white" strokeWidth={2.2} />
              </div>
              <div>
                <span className="text-base font-bold text-gray-900 tracking-tight">ChefMax</span>
                <span className="ml-1.5 text-[10px] font-semibold text-primary-600 uppercase tracking-wider">LATAM</span>
              </div>
            </Link>

            {/* Nav */}
            <nav className="flex items-center gap-2 md:gap-3">
              {isAuthenticated ? (
                <>
                  <span className="hidden sm:flex items-center gap-2 text-sm text-gray-600">
                    <div className="w-7 h-7 rounded-full bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center text-xs font-bold text-white">
                      {(user?.firstName || user?.email || 'U')[0].toUpperCase()}
                    </div>
                    Hola, <strong className="text-gray-900 font-semibold">{user?.firstName || 'Usuario'}</strong>
                  </span>
                  <button
                    onClick={handleLogout}
                    className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
                  >
                    <LogOut className="w-4 h-4" />
                    <span className="hidden sm:inline">Salir</span>
                  </button>
                </>
              ) : (
                <>
                  {isCartFlow && (
                    <span className="hidden md:block text-sm text-gray-500 mr-2">Regístrate o inicia sesión para continuar</span>
                  )}
                  <Link
                    to="/login"
                    className="flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-medium text-white bg-primary-700 hover:bg-primary-800 transition-colors"
                  >
                    <LogIn className="w-4 h-4" />
                    Iniciar sesión
                  </Link>
                  <Link
                    to="/register"
                    className="flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-medium text-primary-700 border border-primary-200 hover:bg-primary-50 transition-colors"
                  >
                    <UserPlus className="w-4 h-4" />
                    <span className="hidden sm:inline">Registrarse</span>
                  </Link>
                </>
              )}
            </nav>
          </div>
        </header>
      )}

      {/* Main */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Cart Sidebar */}
      {!isAuthPage && <CartSidebar />}
    </div>
  )
}
